import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import { jobLocationDelete, jobLocationStatusChange } from "../../helpers/api_helper";
import Confirm from "../Elements/Confirm";

const JobLocationItem = ({
  type,
  locationId,
  index,
  createdBy,
  createdDate,
  updatedDate,
  status,
  query,
  detailsFetch,
  setEditId,
  setEditModal,
}) => {


  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState(false);



  const deleteProduct = useMutation(
    (delProductId) => jobLocationDelete(delProductId),
    {
      onSuccess: (res) => {
        // console.log(res);
        if (res.status === 200) {
          toast.success(res.message);
          queryClient.invalidateQueries(query);
          queryClient.removeQueries({
            queryKey: ["jobLocation"],
            type: "inactive",
          });
        }
        if (res.status === 400) {
          toast.error(res.message);
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );


  const statusChange = useMutation(
    (changeSts) => jobLocationStatusChange(changeSts),
    {
      onSuccess: (res) => {
        // console.log(res);
        if (res.status === 200) {
          toast.success(res.message);
          queryClient.invalidateQueries(query);
          queryClient.removeQueries({
            queryKey: ["jobLocation"],
            type: "inactive",
          });
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );
  return (
    <>
      <div className="location-item mb-3">
        <div className="location-item-row">
          <div className="location-content">
            <div className="location-details">
              <span>Name</span>
              <div className="location-title">{type}</div>
            </div>
          </div>
          <div className="location-options">
            <div className={"status " + (status ? 'published' : 'draft')}>
              {status ? 'published' : 'draft'}
            </div>
            <div className="action-dropdown dropdown">
              <button
                type="button"
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                <i className="fa-regular fa-fw fa-ellipsis-vertical"></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    setEditModal(true);
                    setEditId(locationId);
                    detailsFetch();
                  }}
                >
                  <i className="fa-regular fa-fw fa-pen-to-square"></i>Edit
                </button>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => statusChange.mutate({
                    id: locationId,
                    status: status ? false : true,
                  })}
                >
                  <i className="fa-regular fa-fw fa-arrow-up-from-dotted-line"></i>
                  {status ? 'draft' : 'publish'}
                </button>
                <button
                  type="button"
                  className="dropdown-item standOut"
                  onClick={() => setDeleteModal(true)}
                >
                  <i className="fa-regular fa-fw fa-trash-can"></i>Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {(createdBy || createdDate || updatedDate) && (
          <div className="location-item-row border-t">
            <div className="location-info">
              {createdBy && (
                <div className="info">
                  <div className="info-label">Created By</div>
                  <div className="info-data">{createdBy}</div>
                </div>
              )}
            </div>
            <div className="location-info">
              {createdDate && (
                <div className="info">
                  <div className="info-label">Created Date</div>
                  <div className="info-data">{createdDate}</div>
                </div>
              )}
              {updatedDate && (
                <div className="info">
                  <div className="info-label">Last Updated</div>
                  <div className="info-data">{updatedDate}</div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Confirm
        icon={"fa-regular fa-xmark"}
        iconColorClass={"bg-danger"}
        title={"Delete"}
        text={"Are you really want to delete this?"}
        isOpen={deleteModal}
        confirmClose={() => setDeleteModal(false)}
        confirmSubmit={() => {
          deleteProduct.mutate({ id: locationId });
        }}
      />
    </>
  );
};

export default JobLocationItem;
